import { CarouselModule } from 'ngx-owl-carousel-o'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { OptionsNgxOwCarouselService } from 'dmmp-services'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { BannerFullComponent } from './banner-full.component'
import { BrowserModule } from '@angular/platform-browser'
import { SharedModule } from '../shared/shared.module'



@NgModule({
  declarations: [BannerFullComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CarouselModule,
    CommonModule,
    SharedModule
  ],
  exports: [BannerFullComponent],
  providers: [OptionsNgxOwCarouselService]
})
export class BannerFullModule { }
